/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from '../sign-in/slice';
/**
 * Initial states of hotel function are defined here
 */
export const initialState = {
  //
  loading: false,
  hotels: [],
  hotelById: [],
  currencyData: [],
  hotelUsers: [],
};
/**
 * All actions related to hotel feature are defined here
 */
export const hotelSlice = createSlice({
  name: 'feature/hotels',
  initialState,
  reducers: {
    getHotels(state) {
      state.loading = true;
    },
    getHotelsSucceeded(state, action) {
      state.loading = false;
      state.hotels = action?.payload?.results?.map((data) => ({
        ...data,
        collection: data?.collections,
      }));
    },
    getHotelsFailed(state) {
      state.loading = false;
    },
    createHotel(state) {
      state.loading = true;
    },
    createHotelSucceeded(state, action) {
      state.loading = false;
      state.hotels = [...state.hotels, action?.payload];
    },
    createHotelFailed(state) {
      state.loading = false;
    },
    updateHotel(state) {
      state.loading = true;
    },
    updateHotelSucceeded(state, action) {
      state.loading = false;
      state.hotels = state?.hotels?.map((object) =>
        object?.id === action?.payload?.id ? { ...object, ...action.payload } : object
      );
    },
    updateHotelFailed(state) {
      state.loading = false;
    },
    deleteHotel(state) {
      state.loading = true;
    },
    deleteHotelSucceeded(state, action) {
      state.loading = false;
      state.hotels = state?.hotels?.filter((object) => object?.id !== action?.payload?.data?.id);
    },
    deleteHotelFailed(state) {
      state.loading = false;
    },
    getHotelById(state) {
      state.loading = true;
    },
    getHotelByIdSucceeded(state, action) {
      state.loading = false;
      state.hotelById = action?.payload;
    },
    getHotelByIdFailed(state) {
      state.loading = false;
    },
    getCurrencyData(state) {
      state.loading = true;
    },
    getCurrencyDataSucceeded(state, action) {
      state.loading = false;
      state.currencyData = action?.payload.results;
    },
    getCurrencyDataFailed(state) {
      state.loading = false;
    },
    getHotelUserData(state) {
      state.loading = true;
    },
    getHotelUserDataSucceeded(state, action) {
      state.loading = false;
      state.hotelUsers = action?.payload
        ?.filter((user) => user?.username !== null)
        ?.reduce((acc, current) => {
          if (!acc?.some((user) => user?.username === current?.username)) {
            acc?.push(current);
          }
          return acc;
        }, [])
        ?.sort((a, b) => a?.username?.localeCompare(b?.username));
    },
    getHotelUserDataFailed(state) {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: hotelActions } = hotelSlice;
